var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"message"}},[(_vm.isShowing)?_c('div',{staticClass:"popup-message-container",class:{ 'danger': _vm.danger }},[_c('div',{staticClass:"popup-message-text",domProps:{"innerHTML":_vm._s(_vm.message)}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }